<template>
  <div class="landing" fluid fill-height>
    <v-card-text v-if="closeAndReload" class="text-center text-h5">
      {{ $t('message.close_and_reload') }}
    </v-card-text>
    <div v-else>
      <v-progress-linear indeterminate color="error" height="40"></v-progress-linear>
      <v-card-text class="text-caption text-center">
        {{ $t('message.loading_jiu_jitsu') }}
      </v-card-text>
      <div class="text-center text-overline">
        v{{ systemVersion }}
      </div>
    </div>
  </div>
</template>

<script>
import AuthenticationService from '@/services/AuthenticationService';
import { Environment } from "@/services/Environment";

export default {
  data() {
    return {
      token: this.$route.params.token,
      appVersion: this.$route.query.appv,
      redirect: this.$route.query.r,
      embed: this.$route.query.embed,
      lat: this.$route.query.lat,
      lon: this.$route.query.lon,
      closeAndReload: false,
      systemVersion: Environment.get("VUE_APP_VERSION")
    }
  },
  mounted() {
    this.login()
  },
  methods: {
    goToLogin() {
      window.location = '/login'
    },
    async login() {
      try {
        if (!this.token) {
          this.goToLogin();
          return;
        } else {
          if (this.appVersion && this.appVersion != "") {
            if (this.$store.state.appVersion != this.appVersion) {
              this.$store.dispatch("setAppVersion", this.appVersion);
            }
          }
          AuthenticationService.authenticateWithToken({
            token: this.token,
            appVersion: this.appVersion ? this.appVersion : null
          })
            .then(response => {
              if (response.data.token) {
                //GO to home
                this.$store.dispatch("setToken", null);
                this.$store.dispatch("setUser", null);
                localStorage.removeItem("token");
                this.processLoggedIn(response);
              } else {
                //if you are logged in, go ahead and stay there
                console.log('No token for some reason')
              }
            })
            .catch(() => {
              console.log('We are going to login!')
              if (this.embed && this.embed == 'true') {
                this.closeAndReload = true;
              } else if (localStorage.token) {
                this.navigateTo({ name: 'home', query: { lat: this.lat, lon: this.lon } })
              } else {
                this.goToLogin();
              }
            });
        }
      } catch (err) {
        if (err)
          this.goToLogin();
      }
    },
    processLoggedIn(response) {
      if (response.data.token) {
        this.$store.dispatch("setToken", response.data.token);
        this.$store.dispatch("setUser", response.data.user);
        this.$store.dispatch("setName", response.data.user.fName);
        this.$store.dispatch("setInApp", true);
        this.$store.dispatch("setUserImage",
          (response.data.user.userImageSmall ?
            response.data.user.userImageSmall :
            response.data.user.userImage));
        this.$store.dispatch("setLanguage", response.data.user.lang);
        this.$i18n.locale = response.data.user.lang;

        // Use explicit setItem for better reliability on high-latency writes
        localStorage.setItem("token", response.data.token);

        if (
          response.data.hasLatestAgreement &&
          response.data.hasLatestAgreement == true
        ) {
          localStorage.setItem("hasAgreements", "true");
          this.$store.dispatch("setHasAgreements", true);
        } else {
          localStorage.setItem("hasAgreements", "false");
          this.$store.dispatch("setHasAgreements", false);
        }

        if (this.lat && this.lon) {
          //store this for future use
          this.$store.dispatch("setLat", this.lat);
          this.$store.dispatch("setLon", this.lon);
        }

        // THE SHIELD: Wait 200ms to ensure the browser finishes 
        // the disk write before the window.location kills the JS process.
        setTimeout(() => {
          const embed = this.embed && this.embed == "true" ? true : false;
          if (this.redirect && this.redirect != '')
            window.location = '/secure/' + this.redirect + (embed ? "?embed=true" : "")
          else if (
            response.data.user.academyId
          )
            window.location = '/secure/home?login=true&lat=' + this.lat + '&lon=' + this.lon
          else
            window.location = '/secure/history'
        }, 200);
      } else {
        this.error = 'Unknown';
      }
    }
  }
}
</script>

<style scoped></style>